export const fetchAllCelerationCategoriesBegin = 'FETCH_ALL_CELERATION_CATEGORIES_BEGIN'
export const fetchAllCelerationCategoriesSuccess = 'FETCH_ALL_CELERATION_CATEGORIES_SUCCESS'
export const fetchAllCelerationCategoriesFailure = 'FETCH_ALL_CELERATION_CATEGORIES_FAILURE'

export const fetchAllCelerationChartBegin = 'FETCH_ALL_CELERATION_CHARTS_BEGIN'
export const fetchAllCelerationChartSuccess = 'FETCH_ALL_CELERATION_CHARTS_SUCCESS'
export const fetchAllCelerationChartFailure = 'FETCH_ALL_CELERATION_CHARTS_FAILURE'

export const resetCelerationChart = 'RESET_CELERATION_CHART'

export const onCelerationChartChange = 'ON_CELERATION_CHART_CHANGE'
export const onAddCelerationChart = 'ON_ADD_CELERATION_CHART'
export const onSelectCelerationChart = 'ON_SELECT_CELERATION_CHART'
export const onUpdateCelerationChart = 'ON_UPDATE_CELERATION_CHART'
export const onRecordingParametersChange = 'ON_RECORDING_PARAMETERS_CHANGE'

export const onPointChange = 'ON_POINT_CHANGE'
export const onSelectPoint = 'ON_SELECT_POINT'
export const onUpdatePoint = 'ON_UPDATE_POINT'

export const addPoint = 'Add_POINT'
export const updatePoint = 'UPDATE_POINT'

export const openAddDrawer = 'OPEN_ADD_DRAWER'
export const onDisplaySelectedChart = 'ON_DISPLAY_SELECTED_CHART'

export const onBehaviorTypesChange = 'ON_BEHAVIOR_TYPES_CHANGE'
